import type { ProtocolSnapshot } from "@stonkland/protocol/api-types";

type ConfiguredContracts = Record<string, string | undefined>;

export function protocolDeploymentMatches(
  snapshot: Pick<ProtocolSnapshot, "chainId" | "contracts"> | undefined,
  expectedChainId: number,
  expectedContracts: ConfiguredContracts,
) {
  if (!snapshot || snapshot.chainId !== expectedChainId) return false;

  return Object.entries(expectedContracts).every(
    ([key, expectedAddress]) =>
      Boolean(expectedAddress) &&
      snapshot.contracts[key]?.toLowerCase() === expectedAddress?.toLowerCase(),
  );
}
